export default {
  TOGGLE_BUG_REPORT_DIALOG: ({ commit }, payload) => {
    commit('TOGGLE_BUG_REPORT_DIALOG', payload)
  }
};